module.exports = __webpack_public_path__ + "media/images/diy/awards_picture-af52b7ef2d91051ca6bcc2f660771069.png";